'use client';

import React from 'react';

import Location from '@icons/Location.svg';

import { AdressText, TextContainer } from '../styles';

interface AddressProps {
  name: string;
  address: string;
}

/**
 * Clickable address component that opens the address in Google Maps when clicked.
 * used on Listing page and shift modal info section
 * @param props.name - The name of the school
 * @param props.address - The address
 */
export const ClickableAddress: React.FC<AddressProps> = ({ name, address }) => {
  if (!address) {
    return null;
  }

  const handleAddressClick = () => {
    const searchQuery = `${name}, ${address}`;
    const mapsUrl = `https://www.google.com/maps/search/${encodeURIComponent(searchQuery)}`;
    window.open(mapsUrl, '_blank');
  };

  return (
    <TextContainer onClick={handleAddressClick} style={{ cursor: 'pointer' }}>
      <Location />
      <AdressText>{address}</AdressText>
    </TextContainer>
  );
};
